// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { ReactToRactiveAdapter } from '../../ReactToRactiveAdapter';
import { AutoCompleteQuickTable } from '../../ReactControls/elements/AutoCompleteQuickTable';
export class AutoCompleteTableQuickRactive extends ReactToRactiveAdapter {
    constructor() {
        super();
    }
    static show(props) {
        AutoCompleteTableQuickRactive.hide();
        AutoCompleteTableQuickRactive.instance = new AutoCompleteTableQuickRactive();
        AutoCompleteTableQuickRactive.instance.set(props);
        const mountElement = document.getElementById('newLookupSearchMenu');
        AutoCompleteTableQuickRactive.instance.render(mountElement);
    }
    static hide() {
        if (!isNullOrUndefined(AutoCompleteTableQuickRactive.instance)) {
            AutoCompleteTableQuickRactive.instance.teardown();
            AutoCompleteTableQuickRactive.instance = null;
        }
    }
}
AutoCompleteTableQuickRactive.instance = null;
ReactToRactiveAdapter.extendWith(AutoCompleteTableQuickRactive, {
    template: '<div class="auto-complete-table-wrapper"></div>',
    mountContainer: '.auto-complete-table-wrapper',
    reactComponent: AutoCompleteQuickTable,
    data: function () {
        return {
            props: {}
        };
    }
});
